import React, { useState, useEffect } from "react";
import axios from "../../api/axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./UserProfileFormModern.css";
import Layout from "../layout/Layout";
import { useNavigate } from "react-router-dom";

export default function UserProfileForm() {
  const navigate = useNavigate();

  const [step, setStep] = useState(1);

  const userData = JSON.parse(localStorage.getItem("user"));
  const userId = userData?.id || userData?._id;

  const [errors, setErrors] = useState({});
  const [sameAsPhone, setSameAsPhone] = useState(false);

  const [personal, setPersonal] = useState({
    name: "",
    email: "",
    phone: "",
    whatsapp: "",
    currentLocation: "",
    serviceLocation: [],
    whichLocation: []
  });

  const [professional, setProfessional] = useState({
    companyName: "",
    currentLevel: "",
    upcomingLevel: "",
    teamSize: "",
    totalActive: "",
    totalInactive: "",
  });

  const [suggestions, setSuggestions] = useState([]);
  const [activeField, setActiveField] = useState("");

  /* ---------------- AUTO FILL FROM LOCAL STORAGE ---------------- */

  useEffect(() => {

    if (userData) {

      setPersonal((prev) => ({
        ...prev,
        name: userData.name || "",
        email: userData.email || "",
        phone: userData.phone || "",
      }));

      setProfessional((prev) => ({
        ...prev,
        companyName: userData.companyName || "",
      }));

    }

  }, []);


  useEffect(() => {
    const handleClickOutside = (event) => {
      // if click is not inside dropdown or input-group
      if (!event.target.closest(".input-group")) {
        setActiveField("");
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  /* ---------------- FETCH PROFILE ---------------- */

  useEffect(() => {

    const fetchProfile = async () => {

      try {

        const res = await axios.get(`/auth/profile/${userId}`);
        const data = res.data.user;

        setPersonal((prev) => ({
          ...prev,
          whatsapp: data.whatsapp || "",
          currentLocation: data.currentLocation || "",
          serviceLocation: Array.isArray(data.serviceLocation)
            ? data.serviceLocation
            : typeof data.serviceLocation === "string"
              ? data.serviceLocation.split(",")
              : [],
          whichLocation: data.whichLocation || "",
        }));
        const levelNumber = data.currentLevel
          ? Number(data.currentLevel.toString().replace("Level ", ""))
          : "";

        setProfessional((prev) => ({
          ...prev,
          currentLevel: levelNumber,
          upcomingLevel:
            levelNumber && levelNumber < 10
              ? `Level ${levelNumber + 1}`
              : "Max Level",
          teamSize: data.teamSize || "",
          totalActive: data.totalActive || "",
          totalInactive: data.totalInactive || "",
        }));
      } catch (err) {

        console.log(err);

      }

    };

    if (userId) fetchProfile();

  }, [userId]);

  /* ---------------- SAME AS PHONE ---------------- */
  useEffect(() => {
    if (sameAsPhone && personal.phone) {
      setPersonal((prev) => ({
        ...prev,
        whatsapp: personal.phone
      }));
    }
  }, [sameAsPhone, personal.phone]);

  /* ---------------- LOCATION SEARCH API ---------------- */

 const searchLocation = async (query, field) => {

  if (!query || query.length < 2) {
    setSuggestions([]);
    return;
  }

  try {
    const res = await fetch(`https://photon.komoot.io/api/?q=${query}&limit=10`);
    const data = await res.json();

    // ✅ REMOVE DUPLICATES
    const uniqueCities = [
      ...new Set(
        data.features
          .filter((item) => item.properties.country === "India")
          .map(
            (item) =>
              item.properties.city ||
              item.properties.name ||
              item.properties.state ||
              ""
          )
          .filter((city) => city !== "")
      ),
    ];

    const cities = uniqueCities.map((city) => ({ city }));

    setSuggestions(cities);
    setActiveField(field);

  } catch (error) {
    console.log(error);
  }
};

  /* ---------------- SELECT LOCATION ---------------- */

  const selectLocation = (place) => {

    if (activeField === "serviceLocation") {

      const current = Array.isArray(personal.serviceLocation)
        ? personal.serviceLocation
        : [];

      // avoid duplicate city
      if (!current.includes(place.city)) {
        setPersonal((prev) => ({
          ...prev,
          serviceLocation: [...current, place.city],
        }));
      }

    } else {

      setPersonal((prev) => ({
        ...prev,
        [activeField]: place.city,
      }));

    }

    setSuggestions([]);
    setActiveField("");
  };

  /* ---------------- NEXT STEP VALIDATION ---------------- */

  const nextStep = () => {

    let newErrors = {};

    if (!personal.name) newErrors.name = "Name required";
    if (!personal.email) newErrors.email = "Email required";
    if (!personal.phone) newErrors.phone = "Phone required";
    if (!personal.whatsapp) newErrors.whatsapp = "WhatsApp required";

    // Only one location required
    if (
      !personal.currentLocation &&
      !personal.serviceLocation &&
      !personal.whichLocation
    ) {
      newErrors.location = "Please fill at least one location";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      setStep(2);
    }

  };

  const prevStep = () => setStep(1);

  /* ---------------- SUBMIT ---------------- */

  const handleSubmit = async (e) => {

    e.preventDefault();

    let newErrors = {};

    if (!professional.currentLevel)
      newErrors.currentLevel = "Current level required";

    if (!professional.teamSize)
      newErrors.teamSize = "Team size required";

    if (!professional.totalActive)
      newErrors.totalActive = "Total active required";

    if (!professional.totalInactive)
      newErrors.totalInactive = "Total inactive required";

    const team = Number(professional.teamSize);
    const active = Number(professional.totalActive);
    const inactive = Number(professional.totalInactive);

    if (team && active && inactive && team !== active + inactive) {
      newErrors.totalInactive =
        "Active + Inactive must equal Team Size";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    try {

      const payload = {
        ...personal,
        serviceLocation: personal.serviceLocation.join(","),
        whichLocation: personal.whichLocation.join(","),
        ...professional,
        currentLevel: `Level ${professional.currentLevel}`,
      };

      const res = await axios.put(`/auth/update-profile/${userId}`, payload);

      localStorage.setItem("user", JSON.stringify(res.data.user));

      toast.success("Profile updated successfully");

      setTimeout(() => {
        navigate("/user-dashboard");
      }, 1000);

    } catch (err) {

      toast.error(err.response?.data?.message || "Error saving profile");

    }

  };



  return (

    <Layout>

      <div className="profile-form-container">

        <ToastContainer position="top-right" autoClose={3000} />

        <form onSubmit={handleSubmit} className="modern-form">

          <h2>User Profile</h2>

          {/* ---------------- STEP 1 ---------------- */}

          {step === 1 && (

            <div className="form-step">

              <div className="input-group">
                <input
                  type="text"
                  value={personal.name}
                  onChange={(e) =>
                    setPersonal({ ...personal, name: e.target.value })
                  }
                />
                <label>Name *</label>
                {errors.name && <p className="error">{errors.name}</p>}
              </div>

              <div className="input-group">
                <input
                  type="email"
                  value={personal.email}
                  disabled
                  className="readonly-input"
                />
                <label>Email *</label>
                {errors.email && <p className="error">{errors.email}</p>}
              </div>

              {/* Phone */}

              <div className="input-group">
                <input
                  type="text"
                  value={personal.phone}
                  disabled
                  className="readonly-input"
                />
                <label>Phone *</label>

                {errors.phone && <p className="error">{errors.phone}</p>}
              </div>

              {/* Checkbox */}
              <div className="checkbox-group">
                <input
                  type="checkbox"
                  checked={sameAsPhone}
                  onChange={() => {
                    const checked = !sameAsPhone;
                    setSameAsPhone(checked);

                    setPersonal((prev) => ({
                      ...prev,
                      whatsapp: checked ? prev.phone : ""
                    }));
                  }}
                />
                <span>Same as Contact Number</span>
              </div>

              {/* WhatsApp */}
              <div className="input-group">
                <input
                  type="text"
                  value={personal.whatsapp}
                  disabled={sameAsPhone}
                  onChange={(e) =>
                    setPersonal({ ...personal, whatsapp: e.target.value })
                  }
                />
                <label>WhatsApp *</label>
                {errors.whatsapp && <p className="error">{errors.whatsapp}</p>}
              </div>

              {/* CURRENT LOCATION */}

              <div className="input-group">

                <input
                  type="text"
                  value={personal.currentLocation}
                  onFocus={() => setActiveField("currentLocation")}
                  onChange={(e) => {
                    setPersonal({
                      ...personal,
                      currentLocation: e.target.value,
                    });
                    searchLocation(e.target.value, "currentLocation");
                  }}
                />
                <label>Current Location *</label>
                {errors.location && (
                  <p className="error">{errors.location}</p>
                )}

                {suggestions.length > 0 &&
                  activeField === "currentLocation" && (

                    <ul className="location-dropdown">

                      {suggestions.map((place, index) => (

                        <li
                          key={index}
                          onClick={() => selectLocation(place)}
                        >
                          {place.city}
                        </li>

                      ))}

                    </ul>

                  )}

              </div>

              {/* SERVICE LOCATION */}

              <div className="input-group">

                <input
                  type="text"
         
                  onFocus={() => setActiveField("serviceLocation")}
                  onChange={(e) => {
                    searchLocation(e.target.value, "serviceLocation");
                  }}
                />

                <label>Service Location *</label>

                {suggestions.length > 0 && activeField === "serviceLocation" && (
                  <ul className="location-dropdown">
                    {suggestions.map((place, index) => (
                      <li key={index} onClick={() => selectLocation(place)}>
                        {place.city}
                      </li>
                    ))}
                  </ul>
                )}

              </div>

              {/* Selected Locations OUTSIDE input-group */}

              <div className="selected-locations">

                {(Array.isArray(personal.serviceLocation)
                  ? personal.serviceLocation
                  : []).map((loc, index) => (
                    <span key={index} className="location-tag">
                      {loc}

                      <button
                        type="button"
                        onClick={() => {
                          const updated = personal.serviceLocation.filter(
                            (_, i) => i !== index
                          );

                          setPersonal({
                            ...personal,
                            serviceLocation: updated,
                          });
                        }}
                      >
                        ✕
                      </button>
                    </span>
                  ))}

              </div>

              

             {/* WHICH LOCATION */}
<div className="input-group location-group">

  <input
    type="text"

    value={personal.whichLocationInput || ""}
    disabled={personal.whichLocation.length >= 5}
    onFocus={() => setActiveField("whichLocation")}
    onChange={(e) => {
      const value = e.target.value;

      setPersonal({
        ...personal,
        whichLocationInput: value
      });

      if (personal.whichLocation.length >= 5) {
        toast.error("Only 5 locations allowed");
        return;
      }

      searchLocation(value, "whichLocation");
    }}
  />

  <label>Wish Location *</label>

  {/* ❗ Limit Message */}
  {personal.whichLocation.length >= 5 && (
    <p className="error">Only 5 locations allowed</p>
  )}

  {/* Dropdown */}
  {activeField === "whichLocation" &&
    suggestions.length > 0 &&
    personal.whichLocation.length < 5 && (

      <ul className="location-dropdown">

        {[...new Map(suggestions.map(item => [item.city, item])).values()] // ✅ remove duplicates
          .map((place, index) => (

          <li
            key={index}
            onClick={() => {

              const current = personal.whichLocation || [];

              // 🚫 limit check
              if (current.length >= 5) {
                toast.error("Only 5 locations allowed");
                return;
              }

              // 🚫 duplicate check
              if (current.includes(place.city)) {
                toast.error("Location already selected");
                return;
              }

              // ✅ add location
              setPersonal({
                ...personal,
                whichLocation: [...current, place.city],
                whichLocationInput: "" // ✅ clear input
              });

              setSuggestions([]);
              setActiveField("");
            }}
          >
            {place.city}
          </li>

        ))}

      </ul>

    )}

</div>

<div className="selected-locations">

  {(personal.whichLocation || []).map((loc, index) => (
    <span key={index} className="location-tag">

      {loc}

      <button
        type="button"
        onClick={() => {

          const updated = personal.whichLocation.filter(
            (_, i) => i !== index
          );

          setPersonal({
            ...personal,
            whichLocation: updated,
          });

        }}
      >
        ✕
      </button>

    </span>
  ))}

</div>

              <button type="button" className="btn-next mb-3" onClick={nextStep}>
                Next →
              </button>

            </div>

          )}

          {/* ---------------- STEP 2 ---------------- */}

          {step === 2 && (

            <div className="form-step">

              <div className="input-group">
                <input
                  type="text"
                  value={professional.companyName}
                  onChange={(e) =>
                    setProfessional({
                      ...professional,
                      companyName: e.target.value,
                    })
                  }
                />
                <label>Company Name *</label>
              </div>
              <div className="input-group custom-dropdown">
                <select
                  value={professional.currentLevel || ""}
                  onChange={(e) => {
                    const selected = Number(e.target.value);

                    setProfessional((prev) => ({
                      ...prev,
                      currentLevel: selected,
                      upcomingLevel:
                        selected < 10 ? `Level ${selected + 1}` : "Max Level",
                    }));
                  }}
                >
                  <option value="" disabled>Select Level</option>

                  {[...Array(10)].map((_, i) => (
                    <option key={i} value={i + 1}>
                      Level {i + 1}
                    </option>
                  ))}
                </select>

                <label style={{ color: "#2563eb" }}>Current Level *</label>

                {errors.currentLevel && (
                  <p className="error">{errors.currentLevel}</p>
                )}
              </div>
              <div className="input-group">
                <input type="text" value={professional.upcomingLevel} readOnly />
                <label>Upcoming Level</label>
              </div>

              <div className="input-group">
                <input
                  type="number"
                  value={professional.teamSize}
                  onChange={(e) =>
                    setProfessional({
                      ...professional,
                      teamSize: e.target.value,
                    })
                  }
                />
                <label>Team Size *</label>
              </div>

              <div className="input-group">
                <input
                  type="number"
                  value={professional.totalActive}
                  onChange={(e) =>
                    setProfessional({
                      ...professional,
                      totalActive: e.target.value,
                    })
                  }
                />
                <label>Total Active *</label>
              </div>

              <div className="input-group">
                <input
                  type="number"
                  value={professional.totalInactive}
                  onChange={(e) =>
                    setProfessional({
                      ...professional,
                      totalInactive: e.target.value,
                    })
                  }
                />
                <label>Total Inactive *</label>

                {errors.totalInactive && (
                  <p className="error">{errors.totalInactive}</p>
                )}
              </div>
              <div className="form-buttons">

                <button type="button" className="btn-prev mb-3" onClick={prevStep}>
                  ← Back
                </button>

                <button type="submit" className="btn-submit mb-3">
                  Save Profile
                </button>

              </div>

            </div>

          )}

        </form>

      </div>

    </Layout>

  );

}